import {Component, OnInit, OnDestroy} from '@angular/core';
import {OwlCarousel} from '../carousel/owl-carousel.component';
import {UbicacionComponent} from '../ubicacion/ubicacion.component';
import {NodoComponent} from '../nodo/nodo.component';
import {SensorComponent} from '../sensor/sensor.component';
import {AbmAlarmasComponent} from '../abmalarmas/abmalarmas.component';
import {AvisoComponent} from '../aviso/aviso.component';

import {NodoService} from '../nodo/nodo.service';
import {ProgressService} from '../customBrowserXhr/progress.service';
import {PermisoService} from '../permiso/permiso.service';
import {LoginService} from '../login/login.service';

import {Sucursal} from '../sucursal/sucursal';
import {Ubicacion} from '../ubicacion/ubicacion';
import {Nodo} from '../nodo/nodo';
import {Sensor} from '../sensor/sensor';
import {Alarma} from '../alarmas/alarma';
import {Aviso} from '../aviso/aviso';
import * as _ from "lodash";

declare var $: any;

@Component({
    selector: 'AbmGeneral',
    template: require('../../app/abmgeneral/abmgeneral.component.html'),
    styles: [require('../../app/abmgeneral/abmgeneral.component.css')],
    directives: [OwlCarousel, UbicacionComponent, NodoComponent, SensorComponent, AbmAlarmasComponent, AvisoComponent],
})

export class ABMGeneralComponent implements OnInit, OnDestroy {
    sucursales: Sucursal[];
    sucursalSeleccionada: Sucursal;
    ubicacionSeleccionada: Ubicacion;
    nodoSeleccionado: Nodo;
    sensorSeleccionado: Sensor;
    alarmaSeleccionada: Alarma;
    avisoSeleccionado: Aviso;

    permisosSucursal: any;
    permisosAviso: any;
    permisosAlarma: any;
    permisosNodo: any;
    permisosSensor: any;
    permisosUbicacion: any;

    modificacion: string;

    usuarioConectado: any;

    constructor(private nodoService: NodoService,
                private progressService: ProgressService,
                private permisoService: PermisoService,
                private loginService: LoginService) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        this.permisosSucursal = new Map();
        this.permisosAviso = new Map();
        this.permisosAlarma = new Map();
        this.permisosNodo = new Map();
        this.permisosSensor = new Map();
        this.permisosUbicacion = new Map();

        this.usuarioConectado = this.loginService.getDecodeToken();

        this.sucursalSeleccionada = new Sucursal;

        //Arbol de sucursales->ubicaciones->nodos->sensores segun usuario logueado
        this.nodoService.getNodos().subscribe(
            sucursalesConTodo => {
                this.sucursales = sucursalesConTodo;
                this.sucursales.map((sucursal) => {
                    sucursal.ubicaciones.map((ubicacion)=>{
                        ubicacion.nodos.map((nodo)=>{
                            nodo.resumen = Nodo.toString(nodo);
                        })
                    })
                })
            }
        );
        //Pedir permisos
        this.permisosSucursal = new Map();
        this.permisoService.getPermiso("gateway").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisosSucursal.set(permiso.descripcion, true);
            }
        });

        /*$('.tabla').on( 'mousewheel DOMMouseScroll', function (e) {
         console.log(e);
         var e0 = e.originalEvent;
         var delta = e0.wheelDelta || -e0.detail;

         this.scrollTop += ( delta < 0 ? 1 : -1 ) * 5;
         e.preventDefault();
         });*/
    }

    ngOnDestroy() {
    }

    recargar() {
        this.nodoService.getNodos().subscribe(
            sucursalesConTodo => {
                this.sucursales = sucursalesConTodo;
            }
        )
    }

    seleccionarSucursal(id) {
        for (let sucursal of this.sucursales) {
            if (sucursal._id == id) {
                this.sucursalSeleccionada = sucursal;
                break;
            }
        }
        if ($(window).width() < 769)
            this.proximaSlide(1);
        this.ubicacionSeleccionada = new Ubicacion();
        this.nodoSeleccionado = new Nodo();
        this.sensorSeleccionado = new Sensor();
        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").addClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").removeClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").removeClass("active");
    }

    seleccionarUbicacion(id) {
        this.ubicacionSeleccionada = new Ubicacion();
        for (let ubicacion of this.sucursalSeleccionada.ubicaciones) {
            if (ubicacion._id == id) {
                this.ubicacionSeleccionada = ubicacion;
                break;
            }
        }
        if ($(window).width() < 769)
            this.proximaSlide(2);
        else
            this.proximaSlide(1);
        this.nodoSeleccionado = new Nodo();
        this.sensorSeleccionado = new Sensor();
        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").addClass("active");
        $("#circuloSensor").removeClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").removeClass("active");
        setTimeout(()=>$('[data-toggle="tooltip"]').tooltip(), 500);

    }

    agregarUbicacion() {
        this.ubicacionSeleccionada = new Ubicacion();
        this.modificacion = "agregarUbicacion";

        $("#modalUbicacion").modal("show");
    }

    modificarUbicacion(e, id) {
        this.ubicacionSeleccionada = new Ubicacion();
        for (let ubicacion of this.sucursalSeleccionada.ubicaciones) {
            if (ubicacion._id == id) {
                this.ubicacionSeleccionada = ubicacion;
                break;
            }
        }
        $("#modalUbicacion").modal("show");
        this.modificacion = "modificarUbicacion";
        e.stopPropagation();
    }

    eliminarUbicacion(e, id) {
        for (let ubicacion of this.sucursalSeleccionada.ubicaciones) {
            if (ubicacion._id == id) {
                this.ubicacionSeleccionada = ubicacion;
                break;
            }
        }
        $("#confirmacionUbicacion").modal("show");
        this.modificacion = "eliminarUbicacion";

        this.nodoSeleccionado = new Nodo();
        this.sensorSeleccionado = new Sensor();
        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").removeClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").removeClass("active");

        e.stopPropagation();
    }

    seleccionarNodo(id) {
        for (let nodo of this.ubicacionSeleccionada.nodos) {
            if (nodo._id == id) {
                this.nodoSeleccionado = nodo;
                break;
            }
        }
        if ($(window).width() < 769)
            this.proximaSlide(3);
        else
            this.proximaSlide(2);
        this.sensorSeleccionado = new Sensor();
        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").addClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").removeClass("active");
    }

    agregarNodo() {
        this.nodoSeleccionado = new Nodo();
        this.modificacion = "agregarNodo";

        $("#modalNodo").modal("show");
    }

    modificarNodo(e, id) {
        for (let nodo of this.ubicacionSeleccionada.nodos) {
            if (nodo._id == id) {
                this.nodoSeleccionado = nodo;
                break;
            }
        }
        this.modificacion = "modificarNodo";
        $("#modalNodo").modal("show");
        e.stopPropagation();
    }

    duplicarNodo(e, id) {
        for (let nodo of this.ubicacionSeleccionada.nodos) {
            if (nodo._id == id) {
                this.nodoSeleccionado = _.cloneDeep(nodo);
                delete this.nodoSeleccionado._id;
                break;
            }
        }
        this.modificacion = "duplicarNodo";
        $("#modalNodo").modal("show");
        e.stopPropagation();
    }

    eliminarNodo(e, id) {
        for (let nodo of this.ubicacionSeleccionada.nodos) {
            if (nodo._id == id) {
                this.nodoSeleccionado = nodo;
                break;
            }
        }
        this.nodoSeleccionado.borradoPermanente = false;
        this.modificacion = "eliminarNodo";
        $("#confirmacionNodo").modal("show");

        this.sensorSeleccionado = new Sensor();
        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").addClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").removeClass("active");

        e.stopPropagation();
    }

    eliminarPermanenteNodo(e, id) {
        for (let nodo of this.ubicacionSeleccionada.nodos) {
            if (nodo._id == id) {
                this.nodoSeleccionado = nodo;
                break;
            }
        }
        this.nodoSeleccionado.borradoPermanente = true;
        this.modificacion = "eliminarNodo";
        $("#confirmacionNodo").modal("show");

        this.sensorSeleccionado = new Sensor();
        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").addClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").removeClass("active");

        e.stopPropagation();
    }


    seleccionarSensor(id) {
        for (let sensor of this.nodoSeleccionado.sensores_id) {
            if (sensor._id == id) {
                this.sensorSeleccionado = sensor;
                break;
            }
        }
        if ($(window).width() < 769)
            this.proximaSlide(4);
        else
            this.proximaSlide(3);
        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").removeClass("active");
        $("#circuloAlarma").addClass("active");
        $("#circuloAviso").removeClass("active");
    }

    agregarSensor() {
        this.sensorSeleccionado = new Sensor();
        this.modificacion = "agregarSensor";

        $("#modalSensor").modal("show");
    }

    modificarSensor(e, id) {
        for (let sensor of this.nodoSeleccionado.sensores_id) {
            if (sensor._id == id) {
                if (sensor.tipo_id != undefined && sensor.tipo_id._id != undefined)
                    sensor.tipo_id = sensor.tipo_id._id;
                this.sensorSeleccionado = sensor;
                break;
            }
        }
        this.modificacion = "modificarSensor";
        $("#modalSensor").modal("show");
        e.stopPropagation();
    }

    eliminarSensor(e, id) {
        for (let sensor of this.nodoSeleccionado.sensores_id) {
            if (sensor._id == id) {
                this.sensorSeleccionado = sensor;
                break;
            }
        }
        this.modificacion = "eliminarSensor";
        $("#confirmacionSensor").modal("show");

        this.alarmaSeleccionada = new Alarma();
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").removeClass("active");
        $("#circuloAlarma").addClass("active");
        $("#circuloAviso").removeClass("active");

        e.stopPropagation();
    }

    seleccionarAlarma(id) {
        for (let alarma of this.sensorSeleccionado.alarmas) {
            if (alarma._id == id) {
                this.alarmaSeleccionada = alarma;
                break;
            }
        }
        if ($(window).width() < 769)
            this.proximaSlide(5);
        else
            this.proximaSlide(4);
        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").removeClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").addClass("active");
    }

    agregarAlarma() {
        this.alarmaSeleccionada = new Alarma();
        this.modificacion = "agregarAlarma";

        $("#modalAlarma").modal("show");
    }

    modificarAlarma(e, id) {
        for (let alarma of this.sensorSeleccionado.alarmas) {
            if (alarma._id == id) {
                this.alarmaSeleccionada = alarma;
                break;
            }
        }
        this.modificacion = "modificarAlarma";
        $("#modalAlarma").modal("show");
        e.stopPropagation();
    }

    eliminarAlarma(e, id) {
        for (let alarma of this.sensorSeleccionado.alarmas) {
            if (alarma._id == id) {
                this.alarmaSeleccionada = alarma;
                break;
            }
        }
        this.modificacion = "eliminarAlarma";
        $("#confirmacionAlarma").modal("show");

        this.avisoSeleccionado = new Aviso();

        $("#circuloUbicacion").removeClass("active");
        $("#circuloNodo").removeClass("active");
        $("#circuloSensor").removeClass("active");
        $("#circuloAlarma").removeClass("active");
        $("#circuloAviso").addClass("active");

        e.stopPropagation();
    }

    agregarAviso() {
        this.avisoSeleccionado = new Aviso();
        this.avisoSeleccionado.lunes = false;
        this.avisoSeleccionado.martes = false;
        this.avisoSeleccionado.miercoles = false;
        this.avisoSeleccionado.jueves = false;
        this.avisoSeleccionado.viernes = false;
        this.avisoSeleccionado.sabado = false;
        this.avisoSeleccionado.domingo = false;
        this.modificacion = "agregarAviso";

        $("#modalAviso").modal("show");
    }

    modificarAviso(e, id) {
        for (let aviso of this.alarmaSeleccionada.avisosLista) {
            if (aviso._id == id) {
                this.avisoSeleccionado = aviso;
                break;
            }
        }
        this.modificacion = "modificarAviso";
        $("#modalAviso").modal("show");
        e.stopPropagation();
    }

    eliminarAviso(e, id) {
        for (let aviso of this.alarmaSeleccionada.avisosLista) {
            if (aviso._id == id) {
                this.avisoSeleccionado = aviso;
                break;
            }
        }
        this.modificacion = "eliminarAviso";
        $("#confirmacionAviso").modal("show");
        e.stopPropagation();
    }


    proximaSlide(posicion) {
        var owl = $('.owl-carousel');
        owl.owlCarousel();
        // Go to the next item
        owl.trigger('to.owl.carousel', [posicion, 1000, true]);
    }

    avanzar() {
        var owl = $('.owl-carousel');
        owl.trigger('next.owl.carousel');
    }

    retroceder() {
        var owl = $('.owl-carousel');
        owl.trigger('prev.owl.carousel');

    }

    exportar() {
        let csvContent = "Ubicación,Nodo,Canal de Monitorización,Alarma,Aviso \n";
        for (let ubicacion of this.sucursalSeleccionada.ubicaciones) {
            csvContent += ubicacion.descripcion + "\n";
            for (let nodo of ubicacion.nodos) {
                csvContent += "," + nodo.nombre + " - " + nodo.etiqueta + "\n";
                for (let sensor of nodo.sensores_id) {
                    csvContent += ",," + sensor.etiqueta + "\n";
                    for (let alarma of sensor.alarmas) {
                        csvContent += ",,," + alarma.descripcion + "\n";
                        for (let aviso of alarma.avisosLista) {
                            csvContent += ",,,," + aviso.nombre + "\n";
                        }
                    }
                }
            }
        }
        var a = document.createElement('a');
        a.href = 'data:attachment/csv,' + encodeURIComponent(csvContent);
        a.target = '_blank';
        var d = new Date();

        var datestring = d.getDate() + "" + (d.getMonth() + 1) + "" + d.getFullYear() + " " +
            d.getHours() + "" + d.getMinutes();
        a.download = this.sucursalSeleccionada.descripcion + "-" + datestring + '.csv';

        document.body.appendChild(a);
        a.click();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/abmgeneral/abmgeneral.component.ts